import { ServicePrimaryTag } from "entities/tagTypes/types";
import { QueryDocumentSnapshot, Timestamp } from "firebase/firestore";
import { DocumentData, DocumentSnapshot } from "shared/api/firebase";

type TagTypeDBT = {
  id: string;
  name: string;
  createdAt: Timestamp;
};

type TagTypeDataT = Omit<TagTypeDBT, "id">;

export class TagTypeDB {
  id: string;

  name: string;

  createdAt: Timestamp;

  constructor(tag: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>) {
    if (!tag.exists()) {
      throw new Error(`Tag ${tag.id} does not exist`);
    }

    const data = tag.data() as TagTypeDataT;

    this.id = tag.id;
    this.name = data.name;
    this.createdAt = data.createdAt;
  }

  toTagType(): ServicePrimaryTag {
    return {
      id: this.id,
      name: this.name,
      createdAt: this.createdAt ? this.createdAt?.toDate() : new Date(),
    };
  }
}
